import { useState } from "react";

// Local editing state for an initiative draft
const useItemDraft = (initialItem) => {
  const [draft, setDraft] = useState(initialItem);

  const setField = (field, value) =>
    setDraft((prev) => ({ ...prev, [field]: value }));

  const addToField = (field, item, keyFn = (v) => v) => {
    if (!item || draft[field].some((v) => keyFn(v) === keyFn(item))) return;
    setDraft((prev) => ({ ...prev, [field]: [...prev[field], item] }));
  };

  const removeFromField = (field, key, keyFn = (v) => v) =>
    setDraft((prev) => ({
      ...prev,
      [field]: prev[field].filter((v) => keyFn(v) !== key),
    }));

  return { draft, setDraft, setField, addToField, removeFromField };
};

export default useItemDraft;
